import React, { useEffect, useRef, useState } from "react";
import Style from "./style.module.css";
import InnerLoader from "../../../../component/ui/loader/inner-loader";
import DataNotFound from "../../../../component/ui/loader/data-not-found";
import {
  Calendar,
  CheckCircle2,
  FolderTree,
  ListIcon,
  Package,
  PlusIcon,
  Share2,
  ShieldX,
  ThumbsDown,
  ThumbsUp,
} from "lucide-react";
import { useApiCall } from "../../../../component/custom-hooks/api-call";
import DynamicFilter from "../../../../component/table/filter-table/dynamic-filter";
import FilterFunnel01Icon from "../../../../component/icons/filter-funnel-01";
import { Alert, Skeleton, Snackbar } from "@mui/material";
import moment from "moment";
import CustomizeTabsPopup from "../../../../component/table/customize-table";
import LayoutTopIcon from "../../../../component/icons/layout-top";
import { Link } from "react-router";
import DealQuickView from "./popup";
import Chip from "../../../../component/ui/chip";
import DealBoard from "./kanban/DealBoard";
import { CustomDropdown } from "../../../../component/ui/dropdown/CustomDropdown";
import { CustomDropdownButton } from "../../../../component/ui/dropdown/CustomDropdownButton";
import DotsVerticalIcon from "../../../../component/icons/dots-vertical";
import { CustomDropdownMenu } from "../../../../component/ui/dropdown/CustomDropdownMenu";
import { CustomDropdownMenuList } from "../../../../component/ui/dropdown/CustomDropdownMenuList";
import WonDeal from "./won-deal/won-form-deal";
import LostDeal from "./lost-deal/lost-form-deal";
import Tooltip from "../../../../component/ui/tooltip";
import {
  Table,
  TableBody,
  TableCard,
  TableCell,
  TableFilterReturn,
  TableHead,
  TableHeaderWrap,
  TableRow,
} from "../../../../component/table/table-layout";
import NewEditIcon from "../../../../component/icons/action-edit-icon";
import NewEyeIcon from "../../../../component/icons/action-eye-icon";
import NewCardIcon from "../../../../component/icons/action-card-icon";
import StatusChip from "../../../../component/ui/chip/status";
import * as XLSX from "xlsx";
import { CustomDropdownMenuDivider } from "../../../../component/ui/dropdown/CustomDropdownMenuDivider";
import ChevronDownIcon from "../../../../component/icons/chevron-down";
import FileCode1Icon from "../../../../component/icons/file-code-1";
import Swal from "sweetalert2";
import EmployeeDirectoryAddUpdate from "../../../organization/emplyee-directory/add-update";

const TeamDeals = () => {
  const [isLoading, setIsLoading] = useState(true);
  const [apiData, setApiData] = useState([]);
  const [showModalFilterTable, setShowModalFilterTable] = useState(false);
  const [filterReturn, setFilterReturn] = useState([]);
  const [saveFilter, setSaveFilter] = useState([]);
  const [tablePagination, setTablePagination] = useState({});
  const [btnLoader, setBtnLoader] = useState(false);
  const [selectedIds, setSelectedIds] = useState([]);
  const [changeModal, setChangeModal] = useState(false);
  const [alertData, setAlertData] = useState({ isShow: false });
  const [currentStatus, setCurrentStatus] = useState("");
  const [brands, setBrands] = useState([]);
  const [tableHeader, setTableHeader] = useState([]);
  const [empPopup, setEmpPopup] = useState(false);
  const [empData, setEmpData] = useState({});
  const [viewType, setViewType] = useState("list");
  const [products, setProducts] = useState([]);
  const [packages, setPackage] = useState([]);
  const [boardFilters, setBoardFilters] = useState([]);
  const [showBoardFilterModal, setShowBoardFilterModal] = useState(false);
  const [groupBy, setGroupBy] = useState();
  const [showModalCustomizeTabs, setShowModalCustomizeTabs] = useState(false);
  const [boardSaveFilters, setBoardSaveFilters] = useState([]);
  const [showAddDealModal, setShowAddDealModal] = useState(false);
  const [showEditModal, setShowEditModal] = useState(false);
  const [selectedDeal, setSelectedDeal] = useState(null);
  const [DealStages, setDealStages] = useState([]);
  const [Clients, setClients] = useState([]);
  const [page, setPage] = useState(1);
  const [hasMoreClients, setHasMoreClients] = useState(true);
  const [isLoadingClients, setIsLoadingClients] = useState(false);
  const [usersList, setUsers] = useState([]);
  const [loadingUsers, setLoadingUsers] = useState(false);

  const [showWonModal, setShowWonModal] = useState(false);
  const [wonFormDeal, setWonFormDeal] = useState(null);

  const [showLostModal, setShowLostModal] = useState(false);
  const [lostFormDeal, setLostFormDeal] = useState(null);

  const [selectedDeals, setSelectedDeals] = useState([]);
  const [exportTo, setExportTo] = useState(false);

  const [pageCount, setPageCount] = useState(1);
  const [pageItemsCount, setPageItemsCount] = useState(10);
  const [total, setTotal] = useState(0);

  const toggleSelectAll = (checked) => {
    if (checked) {
      setSelectedDeals(apiData.map((d) => d.dealid));
    } else {
      setSelectedDeals([]);
    }
  };

  const toggleSelectRow = (dealId) => {
    setSelectedDeals((prev) =>
      prev.includes(dealId)
        ? prev.filter((id) => id !== dealId)
        : [...prev, dealId]
    );
  };

  // 🔹 Main export handler
  const handleExport = async (type, localData = null) => {
    try {
      if (localData && localData.length > 0) {
        exportData(localData, type);
        return;
      }

      const filters = filterReturn || [];
      const page = 1;
      const page_quantity = "all";
      const data = { page, page_quantity, filters };

      Swal.fire({
        title: "Exporting Deals...",
        text: "Please wait while we export your data.",
        allowOutsideClick: false,
        didOpen: () => Swal.showLoading(),
      });

      const filtersObj = data.filters.reduce((acc, f) => {
        if (f.value !== "" && f.value !== null && f.value !== undefined) {
          acc[f.field] = f.value;
        }
        return acc;
      }, {});

      const transformed = {
        page_quantity: String(data.page_quantity || ""),
        page: String(data.page || "1"),
        ...filtersObj,
      };

      const apiData = JSON.stringify(transformed);
      const res = await apiCall({
        url: `deals/deals-list`, // 🔹 your actual endpoint
        method: "post",
        data: apiData,
      });

      const dealsData = res?.data || res?.deals || [];
      if (!dealsData?.length) {
        Swal.fire({
          title: "Warning!",
          text: "No deal data available to export.",
          icon: "warning",
          confirmButtonText: "OK",
          buttonsStyling: false,
          customClass: { confirmButton: Style.customSwalBtn },
        });
        return;
      }

      exportData(dealsData, type);
    } catch (error) {
      console.error("Export Error:", error);
      Swal.fire({
        title: "Error!",
        text: "Something went wrong while exporting deals.",
        icon: "error",
        confirmButtonText: "OK",
        buttonsStyling: false,
        customClass: { confirmButton: Style.customSwalBtn },
      });
    }
  };

  // 🔹 Export logic for Excel or CSV
  const exportData = (data, type) => {
    const visibleColumns = tableHeader
      ?.filter((col) => col.is_visible === 1 && col.show == 1)
      ?.map((col) => ({ key: col.key, label: col.value }));

    const formattedData = data.map((row) => {
      const obj = {};

      // 🧾 Base contact info
      obj["Contact Name"] = row?.contact?.name || "-";

      visibleColumns.forEach(({ key, label }) => {
        if (key === "contact") return; // avoid nested object duplication

        if (key === "made_by") {
          obj[label || "Made By"] = row?.made_by?.name || "-";
        } else if (key === "current_stage") {
          obj[label || "Current Stage"] = row?.current_stage?.dealstatus || "-";
        } else if (key === "is_closed") {
          obj[label || "Closed?"] =
            row[key] === "1" ? "Yes" : row[key] === "0" ? "Not Yet" : "-";
        } else if (["created_at", "updated_at"].includes(key)) {
          obj[label || key] = row[key]
            ? moment(row[key]).format("DD-MMM-YYYY")
            : "-";
        } else if (typeof row[key] === "object" && row[key] !== null) {
          obj[label || key] = JSON.stringify(row[key]);
        } else {
          obj[label || key] = row[key] ?? "-";
        }
      });

      return obj;
    });

    const fileName = `deals_${new Date()
      .toISOString()
      .slice(0, 19)
      .replace(/[:T]/g, "-")}`;

    if (type === "csv") {
      const worksheet = XLSX.utils.json_to_sheet(formattedData);
      const csvContent = XLSX.utils.sheet_to_csv(worksheet);
      const blob = new Blob([csvContent], { type: "text/csv;charset=utf-8;" });
      const link = document.createElement("a");
      link.href = URL.createObjectURL(blob);
      link.download = `${fileName}.csv`;
      link.click();
    } else if (type === "excel") {
      const worksheet = XLSX.utils.json_to_sheet(formattedData);
      const workbook = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(workbook, worksheet, "Deals");
      XLSX.writeFile(workbook, `${fileName}.xlsx`);
    }

    Swal.fire({
      title: "Success!",
      text: "Deal data exported successfully.",
      icon: "success",
      confirmButtonText: "OK",
      buttonsStyling: false,
      customClass: { confirmButton: Style.customSwalBtn },
    });
  };

  const handleClose = () => {
    setAlertData({ isShow: false });
  };

  const getBoardFilter = (val) => {
    setBoardSaveFilters(val);
  };

  const apiCall = useApiCall();

  useEffect(() => {
    getProducts();
    getPackage();
    DealStage();
    getData({});
    fetchUsers();
  }, []);

  const getData = async ({
    filter = filterReturn,
    page,
    page_quantity = pageItemsCount,
  }) => {
    if (!page) {
      setIsLoading(true);
    }
    let apiData = { page: page, page_quantity: 10 };
    let extraUrl = `?page=${page || 1}&page_quantity=${page_quantity}`;
    for (let i = 0; i < filter?.length; i++) {
      extraUrl += `&${filter[i]?.name}=${filter[i]?.value}`;
    }

    try {
      const res = await apiCall({
        method: "get",
        url: `deals/deals-list${extraUrl}`,
        data: apiData,
      });
      if (page) {
        setApiData((prev) => [...prev, ...res.data]);
      } else {
        setApiData(res.data);
      }

      setTableHeader(res?.applied_headers);
      setSaveFilter(res?.custom_filters);
      setTotal(res?.pagination?.total);
      setTablePagination(res?.pagination);
      setBtnLoader(false);
      setIsLoading(false);
    } catch (error) {
      console.warn("Error : ", error);
    }
  };

  const getProducts = async () => {
    try {
      const res = await apiCall({
        method: "get",
        url: "products/products-list?is_paginate=0",
      });

      setProducts(res?.data || []);
    } catch (error) {
      console.warn("Error fetching Products:", error);
    }
  };

  const getPackage = async () => {
    try {
      const res = await apiCall({
        method: "get",
        url: "brands/brand-packages-list?is_paginate=0",
      });

      setPackage(res?.data || []);
    } catch (error) {
      console.warn("Error fetching Package:", error);
    }
  };

  const DealStage = async () => {
    try {
      const res = await apiCall({
        method: "get",
        url: `dealstages/deal-stages-list`,
      });

      // filter out "Won" and "Lost"
      const filteredStages = res.data.filter(
        (stage) => stage.name !== "Won" && stage.name !== "Lost"
      );

      setDealStages(filteredStages);
    } catch (error) {
      console.warn("Error : ", error);
    }
  };

  const loadClients = async (pageNum = 1, search = "") => {
    // agar search active hai to hamesha page 1 hi chalega
    if (search && pageNum > 1) return;

    if (isLoadingClients || (!hasMoreClients && pageNum !== 1)) return;

    if (pageNum === 1) {
      setHasMoreClients(true);
      setPage(1);
    }

    setIsLoadingClients(true);

    try {
      const url = search
        ? `users/customers-list?search=${encodeURIComponent(search)}`
        : `users/customers-list?page=${pageNum}`;

      const res = await apiCall({ method: "get", url });
      const newClients = res?.customers || [];

      if (pageNum === 1) {
        setClients(newClients);
      } else if (newClients.length === 0) {
        setHasMoreClients(false);
      } else {
        setClients((prev) => [...prev, ...newClients]);
      }

      setPage(pageNum);
    } catch (err) {
      console.error("Error fetching users", err);
    } finally {
      setIsLoadingClients(false);
    }
  };

  const fetchUsers = async () => {
    if (loadingUsers) return;
    setLoadingUsers(true);

    try {
      const res = await apiCall({
        method: "get",
        url: `users/agents-list`,
      });

      console.log("Users API Response ===>", res);
      const newUsers = res?.agents || res?.customers || res?.data || [];
      setUsers(newUsers);
    } catch (err) {
      console.error("Error fetching users", err);
    } finally {
      setLoadingUsers(false);
    }
  };

  useEffect(() => {
    loadClients(1); // load first page once
  }, []);

  const onSuccess = (message) => {
    setAlertData({ isShow: true, type: "success", message: message });
    setSelectedIds([]);
    getData({});
    setShowLostModal(false);
    setShowWonModal(false);
  };

  const onError = (message) => {
    setAlertData({ isShow: true, type: "error", message: message });
  };

  const onStatusChange = (value) => {
    setCurrentStatus(value);
    setChangeModal(true);
  };

  const removeFilter = (fIndex) => {
    let allFilter = [...filterReturn];
    allFilter.splice(fIndex, 1);
    setFilterReturn(allFilter);
    getData({ filter: allFilter });
  };

  const filterModalData = [
    {
      name: "name",
      label: "Name",
      options: ["contains"],
      selectedOpt: "contains",
      value: "",
      type: "text",
    },
    {
      name: "dealstatus",
      label: "Status",
      options: ["is"],
      selectedOpt: "is",
      value: "",
      type: "dropdown",
      dropdown: [
        { label: "Won", value: "won" },
        { label: "Lost", value: "lost" },
        { label: "Need Analysis", value: "Need Analysis" },
        { label: "Value Proposition", value: "Value Proposition" },
        { label: "Identify Decision", value: "Identify Decision" },
        { label: "Proposal", value: "Proposal" },
        { label: "Review", value: "Review" },
      ],
      dropdownKey: "label",
      dropdownVal: "value",
      betweenType: "date",
    },
    {
      name: "deal_product",
      label: "Product",
      options: ["is"],
      selectedOpt: "is",
      value: "",
      type: "dropdown",
      dropdown: products,
      dropdownKey: "products",
      dropdownVal: "id",
      betweenType: "date",
    },
    {
      name: "deal_package",
      label: "Package",
      options: ["is"],
      selectedOpt: "is",
      value: "",
      type: "dropdown",
      dropdown: packages,
      dropdownKey: "packagename",
      dropdownVal: "packagename",
      betweenType: "date",
    },
  ];

  const getBoardFilterData = () => {
    if (groupBy === "leadsource") return filterModalData;
    if (groupBy === "created_time") return filterModalData;
    return filterModalData; // default
  };

  const tableRef = useRef(null);

  return (
    <>
      <div className={`${Style.mainBody} `}>
        <div className={Style.teamSpaceDashboard}>
          <div className={Style.teamSpaceDashboard_main}>
            <div className={Style.teamSpaceDashboard_body}>
              <TableFilterReturn
                filterReturn={viewType === "list" ? filterReturn : boardFilters}
                onChange={(allFilter) => {
                  if (viewType == "list") {
                    setFilterReturn(allFilter);
                  } else {
                    setBoardFilters(allFilter);
                  }
                  getData({ filter: allFilter });
                }}
              />

              {/* HEADER */}
              <div className={Style.empDirectory_header}>
                <div className={Style.empDirectory_header_left}>
                  {viewType === "list" ? (
                    <div className={Style.bpfl_select}>
                      <select
                        onChange={(e) => {
                          getData({ page_quantity: e?.target.value });
                          setPageCount(1);
                          setPageItemsCount(e?.target.value);
                        }}
                      >
                        <option value="10">Deals View 10</option>
                        <option value="25">Deals View 25</option>
                        <option value="50">Deals View 50</option>
                        <option value="100">Deals View 100</option>
                        <option value={total}>Deals View all</option>
                      </select>
                    </div>
                  ) : (
                    <div className="text-xl font-bold pl-3 flex items-center gap-1 leading-10 ">
                      Team Pipeline
                    </div>
                  )}
                </div>

                <div className={Style.empDirectory_header_right}>
                  <div className={Style.bpfl_action}>
                    {/* Add lead Button */}

                    <div
                      className={Style.bpfl_action}
                      onClick={() => setShowAddDealModal(true)}
                    >
                      <Tooltip
                        content={"Add Deal"}
                        position={"left center"}
                        className={`${Style.bpfl_actionBtn} ${Style.addBtn}`}
                      >
                        <div className={Style.icon}>
                          <PlusIcon size="1em" />
                        </div>
                      </Tooltip>
                    </div>

                    {/* filter button */}
                    <Tooltip
                      className={Style.bpfl_actionItems}
                      content={"Table Filter"}
                      position={"left center"}
                    >
                      <div
                        className={`${Style.bpfl_actionBtn} ${
                          (
                            viewType === "kanban"
                              ? boardFilters.length
                              : filterReturn.length
                          )
                            ? Style.active
                            : ""
                        }`}
                        onClick={() => {
                          if (viewType === "list")
                            setShowModalFilterTable(true); // list view ke liye
                          if (viewType === "kanban")
                            setShowBoardFilterModal(true); // board view ke liye
                        }}
                      >
                        <div className={Style.icon}>
                          <FilterFunnel01Icon />
                        </div>
                      </div>
                    </Tooltip>

                    {/* List View Button */}
                    <Tooltip
                      className={`${Style.bpfl_actionItems}`}
                      content={"list view"}
                      position={"left center"}
                    >
                      <div
                        className={`${Style.bpfl_actionBtn} ${
                          viewType === "list" ? Style.active : ""
                        }`}
                        onClick={() => {
                          setViewType("list");
                          setGroupBy();
                        }}
                      >
                        <div className={Style.icon}>
                          <ListIcon size={16} />
                        </div>
                      </div>
                    </Tooltip>

                    {/* cutomize tab */}

                    <Tooltip
                      className={`${Style.bpfl_actionItems}`}
                      content={"Customize Table"}
                      position={"left center"}
                    >
                      <div
                        className={`${Style.bpfl_actionBtn} ${
                          viewType === "kanban" ? Style.disabled : ""
                        }`}
                        onClick={() => {
                          if (viewType !== "kanban")
                            setShowModalCustomizeTabs(true);
                        }}
                      >
                        <div className={Style.icon}>
                          <LayoutTopIcon />
                        </div>
                      </div>
                    </Tooltip>

                    <CustomDropdown
                      position="bottom-right"
                      className={`myDropdown`}
                    >
                      <CustomDropdownButton arrow={false} className="btnClass">
                        <DotsVerticalIcon />
                      </CustomDropdownButton>

                      <CustomDropdownMenu>
                        {groupBy != "brand" && (
                          <CustomDropdownMenuList
                            onClick={() => {
                              setGroupBy("brand");
                              setViewType("kanban");
                            }}
                          >
                            <div className="d-flex align-items-center gap-1">
                              <Share2 size={14} /> By Lead Source
                            </div>
                          </CustomDropdownMenuList>
                        )}

                        {groupBy != "dealstatus" && (
                          <CustomDropdownMenuList
                            onClick={() => {
                              setGroupBy("dealstatus");
                              setViewType("kanban");
                            }}
                          >
                            <div className="d-flex align-items-center gap-1">
                              <FolderTree size={14} /> By Smart Buckets
                            </div>
                          </CustomDropdownMenuList>
                        )}

                        {groupBy != "created_time" && (
                          <CustomDropdownMenuList
                            onClick={() => {
                              setGroupBy("created_time");
                              setViewType("kanban");
                            }}
                          >
                            <div className="d-flex align-items-center gap-1">
                              <Calendar size={14} /> By Date
                            </div>
                          </CustomDropdownMenuList>
                        )}

                        {groupBy != "product" && (
                          <CustomDropdownMenuList
                            onClick={() => {
                              setGroupBy("product");
                              setViewType("kanban");
                            }}
                          >
                            <div className="d-flex align-items-center gap-1">
                              <Package size={14} /> By Product
                            </div>
                          </CustomDropdownMenuList>
                        )}

                        {viewType == "list" ? (
                          <>
                            <CustomDropdownMenuDivider />

                            <CustomDropdownMenuList
                              className={Style.CustomDropdownMenuList}
                              closed={false}
                            >
                              <div
                                className={Style.CustomDropdownMenuListBtn}
                                onClick={() => setExportTo(!exportTo)}
                              >
                                <div className="">
                                  <LayoutTopIcon /> Export to
                                </div>
                                <div
                                  className={`${Style.dropArrow} ${
                                    exportTo ? Style.isActive : null
                                  }`}
                                >
                                  <ChevronDownIcon />
                                </div>
                              </div>

                              {exportTo ? (
                                <div className={Style.subItemMenu}>
                                  <CustomDropdownMenuList
                                    className={Style.subItemList}
                                    onClick={() => {
                                      const dataToExport =
                                        selectedDeals.length > 0
                                          ? apiData.filter((d) =>
                                              selectedDeals.includes(d.dealid)
                                            )
                                          : apiData;

                                      // ✅ Call the new unified export function
                                      handleExport("csv", dataToExport);
                                    }}
                                  >
                                    <div className="d-flex align-items-center gap-1">
                                      <FileCode1Icon /> CSV
                                    </div>
                                  </CustomDropdownMenuList>

                                  <CustomDropdownMenuList
                                    className={Style.subItemList}
                                    onClick={() => {
                                      const dataToExport =
                                        selectedDeals.length > 0
                                          ? apiData.filter((d) =>
                                              selectedDeals.includes(d.dealid)
                                            )
                                          : apiData;

                                      // ✅ Call the new unified export function
                                      handleExport("excel", dataToExport);
                                    }}
                                  >
                                    <div className="d-flex align-items-center gap-1">
                                      <FileCode1Icon /> XLSX
                                    </div>
                                  </CustomDropdownMenuList>
                                </div>
                              ) : null}
                            </CustomDropdownMenuList>
                          </>
                        ) : null}
                      </CustomDropdownMenu>
                    </CustomDropdown>
                  </div>
                </div>
              </div>

              <div
                className={Style.empDirectory_body}
                style={
                  viewType == "list"
                    ? { height: "calc(100vh - 100px)" }
                    : { height: "calc(100vh - 50px)" }
                }
              >
                {viewType === "list" ? (
                  isLoading ? (
                    <InnerLoader />
                  ) : !apiData?.length ? (
                    <div className="flex justify-center items-center w-full h-full">
                      <DataNotFound title={"Deals"} />
                    </div>
                  ) : (
                    <>
                      <TableCard ref={tableRef}>
                        <Table>
                          <TableHead>
                            <TableRow>
                              <TableCell header sticky>
                                <div className="flex gap-2 items-center">
                                  <div className={Style.tableCheckBox}>
                                    <label className={Style.custom_checkbox}>
                                      <input
                                        type="checkbox"
                                        checked={
                                          selectedDeals.length ===
                                            apiData.length && apiData.length > 0
                                        }
                                        className={Style.customCheckbox}
                                        onChange={(e) =>
                                          toggleSelectAll(e.target.checked)
                                        }
                                      />
                                      <span className={Style.checkmark}></span>
                                    </label>
                                  </div>
                                  <TableHeaderWrap>
                                    <span className="pl-[50px]">Name</span>
                                  </TableHeaderWrap>
                                </div>
                              </TableCell>
                              {tableHeader?.map((eachHead, index) =>
                                eachHead.is_visible === 1 &&
                                eachHead?.show == 1 ? (
                                  <TableCell header key={index}>
                                    <TableHeaderWrap>
                                      <span>{eachHead?.value}</span>
                                    </TableHeaderWrap>
                                  </TableCell>
                                ) : null
                              )}
                            </TableRow>
                          </TableHead>

                          <TableBody>
                            {apiData?.map((eachList, index) => {
                              return (
                                <TableRow key={`${index}`}>
                                  <TableCell sticky>
                                    <div
                                      className={`${Style.tableActionArea} !gap-4`}
                                    >
                                      <div className="flex gap-2 items-center">
                                        <div className={Style.tableCheckBox}>
                                          <label
                                            className={Style.custom_checkbox}
                                          >
                                            <input
                                              type="checkbox"
                                              className={Style.customCheckbox}
                                              checked={selectedDeals.includes(
                                                eachList.dealid
                                              )}
                                              onChange={() =>
                                                toggleSelectRow(eachList.dealid)
                                              }
                                            />
                                            <span
                                              className={Style.checkmark}
                                            ></span>
                                          </label>
                                        </div>

                                        <div className="flex items-center gap-3">
                                          <div className="">
                                            {eachList?.contact?.userimg ? (
                                              <img
                                                className="h-9 w-9 shrink-0 rounded-full bg-gradient-to-br from-indigo-500/20 to-emerald-500/20 grid place-items-center text-xs font-medium object-cover object-center"
                                                src={eachList?.contact?.userimg}
                                                alt={eachList?.contact?.name}
                                                onError={(e) => {
                                                  e.target.classList.add(
                                                    "hidden"
                                                  );
                                                  if (e.target.parentElement) {
                                                    e.target.parentElement.innerHTML = `
                                                <div class="h-9 w-9 shrink-0 rounded-full bg-gradient-to-br from-indigo-500/20 to-emerald-500/20 grid place-items-center text-xs font-medium">
                                                  ${
                                                    eachList?.contact?.name?.split(
                                                      " "
                                                    )[0]?.[0] || ""
                                                  }${
                                                      eachList?.contact?.name?.split(
                                                        " "
                                                      )[1]?.[0] || ""
                                                    }
                                                </div>`;
                                                  }
                                                }}
                                              />
                                            ) : (
                                              <div className="h-9 w-9 shrink-0 rounded-full bg-gradient-to-br from-indigo-500/20 to-emerald-500/20 grid place-items-center text-xs font-medium">
                                                {eachList?.contact?.name?.split(
                                                  " "
                                                )[0]
                                                  ? eachList?.contact?.name?.split(
                                                      " "
                                                    )[0][0]
                                                  : ""}
                                                {eachList?.contact?.name?.split(
                                                  " "
                                                )[1]
                                                  ? eachList?.contact?.name?.split(
                                                      " "
                                                    )[1][0]
                                                  : ""}
                                              </div>
                                            )}
                                          </div>
                                          <div className="font-medium leading-5">
                                            {eachList?.contact?.name}
                                          </div>
                                        </div>
                                      </div>

                                      <div
                                        className={
                                          Style.tableActionAreaBtnGrpup
                                        }
                                      >
                                        <div
                                          className={`w-7 h-7 flex items-center justify-center rounded-md bg-[rgba()] shadow-[0_4px_12px_rgba(0,0,0,0.08)] border border-gray-100 hover:scale-105 transition-transform duration-300 
                                                      ${
                                                        eachList?.current_stage
                                                          ?.dealstatus ===
                                                          "Won" ||
                                                        eachList?.current_stage
                                                          ?.dealstatus ===
                                                          "Lost"
                                                          ? "opacity-50 cursor-not-allowed"
                                                          : ""
                                                      }`}
                                          disabled={
                                            eachList?.current_stage
                                              ?.dealstatus === "Won" ||
                                            eachList?.current_stage
                                              ?.dealstatus === "Lost"
                                          }
                                          onClick={() => {
                                            if (
                                              eachList?.current_stage
                                                ?.dealstatus === "Won" ||
                                              eachList?.current_stage
                                                ?.dealstatus === "Lost"
                                            )
                                              return;
                                            setSelectedDeal(eachList);
                                            setShowEditModal(true);
                                          }}
                                        >
                                          <div
                                            className={Style.icon}
                                            style={{ color: "#FF9500" }}
                                          >
                                            <NewEditIcon className="h-4.5 w-4.5" />
                                          </div>
                                        </div>

                                        {/* Mark as Won */}
                                        <button
                                          className={`${Style.btn} ${
                                            eachList?.current_stage
                                              ?.dealstatus === "Won" ||
                                            eachList?.current_stage
                                              ?.dealstatus === "Lost"
                                              ? "opacity-60 cursor-not-allowed"
                                              : ""
                                          }`}
                                          onClick={() => {
                                            if (
                                              eachList?.current_stage
                                                ?.dealstatus === "Won" ||
                                              eachList?.current_stage
                                                ?.dealstatus === "Lost"
                                            )
                                              return;
                                            setWonFormDeal(eachList);
                                            setShowWonModal(true);
                                          }}
                                          disabled={
                                            eachList?.current_stage
                                              ?.dealstatus === "Won" ||
                                            eachList?.current_stage
                                              ?.dealstatus === "Lost"
                                          }
                                        >
                                          <div
                                            className={
                                              "w-7 h-7 flex items-center justify-center rounded-md bg-[rgba(255,255,255,0.2)] shadow-[0_4px_12px_rgba(0,0,0,0.08)] border border-gray-100 hover:scale-105 transition-transform duration-300"
                                            }
                                          >
                                            <div
                                              className={Style.icon}
                                              style={{
                                                color:
                                                  eachList?.current_stage
                                                    ?.dealstatus === "Won"
                                                    ? "#16a34a"
                                                    : "#9ca3af",
                                              }}
                                            >
                                              <ThumbsUp
                                                className={`h-4.5 w-4.5  ${
                                                  eachList?.current_stage
                                                    ?.dealstatus === "Won" ||
                                                  eachList?.current_stage
                                                    ?.dealstatus === "Lost"
                                                    ? "opacity-60 cursor-not-allowed"
                                                    : ""
                                                }`}
                                              />
                                            </div>
                                          </div>
                                        </button>

                                        <button
                                          className={`${Style.btn} ${
                                            eachList?.current_stage
                                              ?.dealstatus === "Won" ||
                                            eachList?.current_stage
                                              ?.dealstatus === "Lost"
                                              ? "opacity-60 cursor-not-allowed"
                                              : ""
                                          }`}
                                          onClick={() => {
                                            if (
                                              eachList?.current_stage
                                                ?.dealstatus === "Won" ||
                                              eachList?.current_stage
                                                ?.dealstatus === "Lost"
                                            )
                                              return;
                                            setLostFormDeal(eachList);
                                            setShowLostModal(true);
                                          }}
                                          disabled={
                                            eachList?.current_stage
                                              ?.dealstatus === "Won" ||
                                            eachList?.current_stage
                                              ?.dealstatus === "Lost"
                                          }
                                        >
                                          <div
                                            className={
                                              "w-7 h-7 flex items-center justify-center rounded-md bg-[rgba(255,255,255,0.2)] shadow-[0_4px_12px_rgba(0,0,0,0.08)] border border-gray-100 hover:scale-105 transition-transform duration-300"
                                            }
                                          >
                                            <div
                                              className={Style.icon}
                                              style={{
                                                color:
                                                  eachList?.current_stage
                                                    ?.dealstatus === "Lost"
                                                    ? "red"
                                                    : "#9ca3af",
                                              }}
                                            >
                                              <ThumbsDown
                                                className={`h-4.5 w-4.5  ${
                                                  eachList?.current_stage
                                                    ?.dealstatus === "Won" ||
                                                  eachList?.current_stage
                                                    ?.dealstatus === "Lost"
                                                    ? "opacity-60 cursor-not-allowed"
                                                    : ""
                                                }`}
                                              />
                                            </div>
                                          </div>
                                        </button>

                                        <div
                                          className={
                                            "w-7 h-7 flex items-center justify-center rounded-md bg-[rgba(255,255,255,0.2)] shadow-[0_4px_12px_rgba(0,0,0,0.08)] border border-gray-100 hover:scale-105 transition-transform duration-300"
                                          }
                                          onClick={() => {
                                            setEmpPopup(true);
                                            setEmpData(eachList);
                                          }}
                                        >
                                          <div
                                            className={Style.icon}
                                            style={{ color: "#007AFF" }}
                                          >
                                            <NewEyeIcon className="h-4.5 w-4.5" />
                                          </div>
                                        </div>

                                        <Link
                                          to={
                                            eachList?.deal_type === "account"
                                              ? `/accounts/account-details/${eachList?.contact?.userid}`
                                              : `/contacts/contact-details/${eachList?.contact?.userid}`
                                          }
                                          state={{
                                            defaultDealId: eachList?.dealid,
                                          }}
                                          className="w-7 h-7 flex items-center justify-center rounded-md bg-[rgba(255,255,255,0.2)] shadow-[0_4px_12px_rgba(0,0,0,0.08)] border border-gray-100 hover:scale-105 transition-transform duration-300"
                                        >
                                          <div
                                            className={Style.icon}
                                            style={{ color: "#34C759" }}
                                          >
                                            <NewCardIcon className="h-4.5 w-4.5" />
                                          </div>
                                        </Link>

                                        <Tooltip
                                          content={
                                            eachList?.schedules
                                              ? `Last schedule: ${eachList?.schedules?.created_at}`
                                              : "No schedule yet"
                                          }
                                          position="top center"
                                          className={Style.btn}
                                        >
                                          <div
                                            className={
                                              "w-7 h-7 flex items-center justify-center rounded-md bg-[rgba(255,255,255,0.2)] shadow-[0_4px_12px_rgba(0,0,0,0.08)] border border-gray-100 hover:scale-105 transition-transform duration-300"
                                            }
                                          >
                                            {eachList?.schedules ? (
                                              <CheckCircle2 className="h-4 w-4 text-emerald-500" />
                                            ) : (
                                              <ShieldX className="h-4 w-4 text-amber-500" />
                                            )}
                                          </div>
                                        </Tooltip>
                                      </div>
                                    </div>
                                  </TableCell>
                                  {tableHeader?.map((eachHead, i) =>
                                    eachHead.is_visible === 1 &&
                                    eachHead?.show == 1 ? (
                                      <>
                                        {eachHead.key === "contact" ? (
                                          <TableCell key={`${i}-${index}`}>
                                            <ul>
                                              <li className="mt-1">
                                                {eachList?.contact?.name}
                                              </li>
                                              <li className="mt-1">
                                                {eachList?.contact?.email}
                                              </li>
                                              <li className="mt-1">
                                                {eachList?.contact?.phone}
                                              </li>
                                            </ul>
                                          </TableCell>
                                        ) : eachHead.key == "email" ? (
                                          <TableCell key={`td-${i}`}>
                                            {eachList[eachHead?.key] ? (
                                              <a
                                                href={
                                                  `mailto:${
                                                    eachList[eachHead?.key]
                                                  }` || ""
                                                }
                                              >
                                                {eachList[eachHead?.key] ||
                                                  "--"}
                                              </a>
                                            ) : (
                                              "--"
                                            )}
                                          </TableCell>
                                        ) : eachHead.key == "is_closed" ? (
                                          <TableCell
                                            key={`${i}-${index}`}
                                            className={`text-center capitalize`}
                                          >
                                            {eachList[eachHead?.key] === "1" ? (
                                              <StatusChip color="green">
                                                Yes
                                              </StatusChip>
                                            ) : eachList[eachHead?.key] ===
                                              "0" ? (
                                              <StatusChip color="red">
                                                Not Yet
                                              </StatusChip>
                                            ) : (
                                              "--"
                                            )}
                                          </TableCell>
                                        ) : eachHead.key === "made_by" ? (
                                          <>
                                            {eachList?.made_by ? (
                                              <TableCell key={`${i}-${index}`}>
                                                <div className="flex items-center gap-3">
                                                  <div className="h-9 w-9 shrink-0 rounded-full bg-gradient-to-br from-indigo-500/20 to-emerald-500/20 grid place-items-center text-xs font-medium">
                                                    {eachList?.made_by
                                                      ?.userimg ? (
                                                      <img
                                                        src={`${eachList?.made_by?.userimg}`}
                                                        alt={
                                                          eachList?.made_by
                                                            ?.name
                                                        }
                                                        className="h-9 w-9 shrink-0 rounded-full object-cover object-center"
                                                        onError={(e) => {
                                                          e.target.classList.add(
                                                            "hidden"
                                                          );
                                                          if (
                                                            e.target
                                                              .parentElement
                                                          ) {
                                                            e.target.parentElement.innerHTML = `
                                                <div class="h-9 w-9 shrink-0 rounded-full bg-gradient-to-br from-indigo-500/20 to-emerald-500/20 grid place-items-center text-xs font-medium">
                                                  ${
                                                    eachList?.made_by?.name.split(
                                                      " "
                                                    )[0]?.[0] || ""
                                                  }${
                                                              eachList?.made_by?.name.split(
                                                                " "
                                                              )[1]?.[0] || ""
                                                            }
                                                </div>`;
                                                          }
                                                        }}
                                                      />
                                                    ) : (
                                                      <div className="h-9 w-9 shrink-0 rounded-full bg-gradient-to-br from-indigo-500/20 to-emerald-500/20 grid place-items-center text-xs font-medium">
                                                        {eachList?.made_by?.name.split(
                                                          " "
                                                        )[0]?.[0] || ""}
                                                        {eachList?.made_by?.name.split(
                                                          " "
                                                        )[1]?.[0] || ""}
                                                      </div>
                                                    )}
                                                  </div>
                                                  <span className="font-medium">
                                                    {eachList?.made_by?.name ||
                                                      "--"}
                                                  </span>
                                                </div>
                                              </TableCell>
                                            ) : (
                                              <TableCell key={`${i}-${index}`}>
                                                -
                                              </TableCell>
                                            )}
                                          </>
                                        ) : eachHead?.key === "created_at" ? (
                                          <TableCell key={`${i}-${index}`}>
                                            {eachList.key
                                              ? moment(
                                                  eachList?.created_at
                                                ).format("DD-MMM-YYYY")
                                              : "-"}
                                          </TableCell>
                                        ) : eachHead?.key ===
                                          "current_stage" ? (
                                          <TableCell
                                            key={`${i}-${index}`}
                                            className={`text-center capitalize`}
                                          >
                                            {eachList?.current_stage
                                              ?.dealstatus ===
                                            "Need Analysis" ? (
                                              <Chip color={"yellow"}>
                                                Need Analysis
                                              </Chip>
                                            ) : eachList?.current_stage
                                                ?.dealstatus ===
                                              "Value Proposition" ? (
                                              <Chip color="blue">
                                                Value Proposition
                                              </Chip>
                                            ) : eachList?.current_stage
                                                ?.dealstatus ===
                                              "Identify Decision" ? (
                                              <Chip color="violet">
                                                Identify Decision
                                              </Chip>
                                            ) : eachList?.current_stage
                                                ?.dealstatus === "Proposal" ? (
                                              <Chip color="teal">Proposal</Chip>
                                            ) : eachList?.current_stage
                                                ?.dealstatus === "Review" ? (
                                              <Chip color="indigo">Review</Chip>
                                            ) : eachList?.current_stage
                                                ?.dealstatus === "Won" ? (
                                              <Chip color="green">Won</Chip>
                                            ) : eachList?.current_stage
                                                ?.dealstatus === "Lost" ? (
                                              <Chip color="red">Lost</Chip>
                                            ) : (
                                              <Chip color="gray">
                                                {eachList?.current_stage
                                                  ?.dealstatus || "--"}
                                              </Chip>
                                            )}
                                          </TableCell>
                                        ) : (
                                          <TableCell key={`${i}-${index}`}>
                                            {eachList[eachHead?.key] ?? "--"}
                                          </TableCell>
                                        )}
                                      </>
                                    ) : null
                                  )}
                                </TableRow>
                              );
                            })}
                          </TableBody>
                        </Table>
                      </TableCard>
                    </>
                  )
                ) : (
                  <DealBoard
                    filters={boardFilters}
                    groupBy={groupBy}
                    sendFilters={getBoardFilter}
                    DealStages={DealStages}
                    onLoadMoreClients={loadClients}
                    hasMoreClients={hasMoreClients}
                    page={page}
                    isLoadingClients={isLoadingClients}
                    PackageList={packages}
                    ProductList={products}
                    ClientList={Clients}
                    UserList={usersList}
                    contactId={selectedDeal?.contactid}
                    onDealUpdated={() => getData({})} // refresh after update
                  />
                )}
              </div>

              {viewType == "list" && apiData?.length > 0 ? (
                <>
                  {" "}
                  {!isLoading ? (
                    <div
                      className={Style.table_footer}
                      style={{ alignItems: "center" }}
                    >
                      <div className={Style.table_footer_left}>
                        {`showing 1 to ${apiData?.length} of ${
                          tablePagination?.total || apiData?.length
                        }`}
                      </div>

                      {tablePagination ? (
                        <div className={Style.empDirectory_footer}>
                          {tablePagination?.next_page_url ? (
                            <button
                              className={Style.loadMoreBtn}
                              onClick={() => {
                                if (btnLoader) return;

                                setBtnLoader(true);

                                getData({
                                  page: tablePagination?.next_page_url,
                                });
                              }}
                            >
                              {btnLoader ? (
                                <InnerLoader
                                  className={Style.loader}
                                  textStatus={false}
                                />
                              ) : (
                                "Load More"
                              )}
                            </button>
                          ) : null}
                        </div>
                      ) : null}

                      <div
                        className={`${Style.table_footer_left} ${Style.rightText}`}
                      ></div>
                    </div>
                  ) : (
                    <div
                      className={Style.table_footer}
                      style={{ alignItems: "center" }}
                    >
                      <div className={Style.table_footer_left}>
                        <Skeleton width={"50%"} height={15} />
                      </div>

                      <div className={Style.empDirectory_footer}>
                        <Skeleton width={"180px"} height={40} />
                      </div>

                      <div
                        className={`${Style.table_footer_left} ${Style.rightText}`}
                      ></div>
                    </div>
                  )}
                </>
              ) : null}
            </div>
          </div>
        </div>
      </div>
      {showModalFilterTable && (
        <DynamicFilter
          data={filterModalData}
          onClose={() => setShowModalFilterTable(false)}
          returnData={filterReturn}
          onSave={(filters, filterName, editingFilter) => {
            getData({ filter: filters });
            setShowModalFilterTable(false);
            setFilterReturn(filters);
          }}
          saveFilter={saveFilter}
          apiUrl="deals-list"
        />
      )}

      {showBoardFilterModal && (
        <DynamicFilter
          data={getBoardFilterData()}
          onClose={() => setShowBoardFilterModal(false)}
          returnData={boardFilters}
          onSave={(filters) => {
            setBoardFilters(filters);
            setShowBoardFilterModal(false);
          }}
          saveFilter={boardSaveFilters}
          apiUrl={`deals-kanban?group_by=${groupBy}`}
        />
      )}

      {showModalCustomizeTabs && (
        <CustomizeTabsPopup
          data={tableHeader}
          onClose={() => {
            setShowModalCustomizeTabs(false);
            const table = tableRef?.current;
            if (table) {
              table.style.zIndex = 1;
            }
          }}
          onPreview={(updatedHeaders) => {
            setTableHeader(updatedHeaders);
            const table = tableRef?.current;
            table.style.zIndex = 100;
          }}
          onPreviewClose={() => {
            const table = tableRef?.current;
            table.style.zIndex = 1;
          }}
          onSave={(saveHeaders) => {
            setTableHeader(saveHeaders);
            const table = tableRef?.current;
            if (table) {
              table.style.zIndex = 1;
            }
          }}
          apiUrl="deals-list"
        />
      )}

      {empPopup && (
        <DealQuickView
          onClose={() => {
            setEmpPopup(false);
            setEmpData({});
          }}
          data={empData}
          DealStages={DealStages}
        />
      )}

      {showEditModal && (
        <EmployeeDirectoryAddUpdate
          open={showEditModal}
          onClose={() => {
            setShowEditModal(false);
            setSelectedDeal(null);
          }}
          data={selectedDeal}
          tabIndex={1}
          contactId={selectedDeal?.contactid}
          onDealUpdated={() => getData({})} // refresh after update
          onSubmit={(msg) => onSuccess(msg)}
          onError={(msg) => onError(msg)}
          Style={Style}
        />
      )}

      {showAddDealModal && (
        <EmployeeDirectoryAddUpdate
          open={showAddDealModal}
          onClose={() => {
            setShowAddDealModal(false);
          }}
          data={null}
          tabIndex={1}
          contactId={null}
          onDealUpdated={() => getData({})} // refresh after update
          onSubmit={(msg) => onSuccess(msg)}
          onError={(msg) => onError(msg)}
        />
      )}

      <Snackbar
        open={alertData?.isShow}
        autoHideDuration={3000}
        onClose={handleClose}
      >
        <Alert
          onClose={handleClose}
          severity={alertData?.type}
          variant="filled"
          sx={{ width: "100%" }}
        >
          {alertData?.message}
        </Alert>
      </Snackbar>

      {showWonModal && (
        <WonDeal
          wonFormDeal={wonFormDeal}
          onClose={() => setShowWonModal(false)}
          onDealUpdated={() => getData({})}
          onSubmit={(msg) => onSuccess(msg)}
          onError={(msg) => onError(msg)}
        />
      )}

      {showLostModal && (
        <LostDeal
          lostFormDeal={lostFormDeal}
          onClose={() => setShowLostModal(false)}
          onDealUpdated={() => getData({})}
          onSubmit={(msg) => onSuccess(msg)}
          onError={(msg) => onError(msg)}
        />
      )}
    </>
  );
};

export default TeamDeals;
